import { Switcher } from "../common/Switcher";

interface Props {
  values: string[];
  selectedValues: string[];
  selectedValuesSetter: (values: string[]) => void;
  valueToLabelMapper?: (value: string) => string;
}

export function FilterButtonGroup({
  values,
  selectedValues,
  selectedValuesSetter,
  valueToLabelMapper,
}: Props) {
  return (
    <>
      {values.map((s: string) => (
        <Switcher
          key={s}
          value={s}
          isActive={selectedValues.includes(s)}
          setIsActive={() => toggleValue(s)}
          valueToLabelMapper={valueToLabelMapper}
        />
      ))}
    </>
  );

  function toggleValue(toggeledValue: string) {
    if (selectedValues.includes(toggeledValue)) {
      selectedValuesSetter(selectedValues.filter((v) => v !== toggeledValue));
    } else {
      selectedValuesSetter(selectedValues.concat(toggeledValue));
    }
  }
}
